import React from 'react';
import { Mail, Phone } from 'lucide-react';

const Footer = ({ translations }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img 
              src="https://atom-logos.fr/logo.png" 
              alt="ATOM LOGOS" 
              className="footer-logo"
            />
            <p className="footer-slogan">{translations.footer.slogan}</p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">{translations.footer.contact}</h4>
            <div className="footer-links">
              <a href="mailto:contact@atom-logos.fr" className="footer-link">
                <Mail size={16} />
                {translations.footer.email}
              </a>
              <a href="tel:+33652648235" className="footer-link">
                <Phone size={16} />
                {translations.footer.phone}
              </a>
            </div>
          </div>

          <div className="footer-section">
            <p className="footer-languages">
              Français • Українська • Русский
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 {translations.footer.company}. {translations.footer.rights}.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
